/*
 * Filtered-collection SEO links for Globo Smart Product Filter.
 * Data: <script type="application/json" id="CollectionFilterSeoLinks"> from
 * snippets/collection-filter-seo-links.liquid:
 *   [{ "filter": "gf_848536=Pneumatic+Tyres", "url": "/collections/x?gf_848536=Pneumatic+Tyres" },
 *    { "type": "Wheelchair Wheel", "url": "/collections/types?q=Wheelchair%20Wheel" }].
 * Every Globo option (#gf-tree .gf-option-box li > button[data-fvalue], role checkbox|radio) whose click
 * would produce exactly an entry's filter state is replaced by an <a href="entry.url"> clone, so crawlers
 * see a real link to the SEO landing page. A plain click on a link to the current page (same collection)
 * works like the Globo option it replaces: no navigation, the click reaches Globo's delegated handler, which
 * filters via AJAX and pushes the same URL. Modified clicks (new tab) and links to another page (a product
 * type page) keep the browser default. A "type" entry links the option with that value (case-insensitive) of a
 * facet whose source is Product type (.gf-option-block[data-filter-type]), when it would be the only
 * selected filter. All other options stay Globo buttons. Re-applied after every Globo render.
 */
(function () {
  'use strict';

  var DATA_ID = 'CollectionFilterSeoLinks';
  var LINK_ATTR = 'data-cfs-link';
  var COPY_ATTRS = ['class', 'role', 'aria-checked', 'aria-label', 'title', 'data-fvalue'];
  var SEP = '\u0001';
  /* Globo writes the facet source into data-filter-type ("Tag", "Vendor", "Collection", ...). */
  var TYPE_SOURCE = /^\s*product[\s_-]*type\s*$/i;
  var entries = null;
  var observer = null;
  var observed = null;
  var observedParent = null;
  var timer = null;
  /* After a link click handed to Globo: no re-linking until Globo re-renders (or this time passes). */
  var HOLD_MS = 4000;
  var holdUntil = 0;

  function prefix() {
    var cfg = window.GloboEmbedFilterConfig;
    return (cfg && cfg.filter && cfg.filter.prefix) || 'gf_';
  }

  function queryOf(str) {
    str = String(str || '').replace(/^\s+|\s+$/g, '');
    var hash = str.indexOf('#');
    if (hash !== -1) str = str.slice(0, hash);
    var q = str.indexOf('?');
    return q === -1 ? str : str.slice(q + 1);
  }

  /* Prefixed key=value pairs (decoded) of a query string, deduplicated. */
  function pairsOf(query) {
    var out = [];
    var pre = prefix();
    var params;
    try {
      params = new URLSearchParams(query);
    } catch (e) {
      return out;
    }
    params.forEach(function (value, key) {
      if (key.indexOf(pre) !== 0) return;
      var pair = key + '=' + value;
      if (out.indexOf(pair) === -1) out.push(pair);
    });
    return out;
  }

  function stateKey(pairs) {
    return pairs.slice().sort().join(SEP);
  }

  function norm(str) {
    return String(str).replace(/^\s+|\s+$/g, '').toLowerCase();
  }

  function loadEntries() {
    var list = [];
    var el = document.getElementById(DATA_ID);
    if (!el) return list;
    var raw;
    try {
      raw = JSON.parse(el.textContent || '[]');
    } catch (e) {
      return list;
    }
    if (!raw || typeof raw.length !== 'number') return list;
    for (var i = 0; i < raw.length; i++) {
      var item = raw[i];
      if (!item || typeof item.url !== 'string' || !item.url) continue;
      if (typeof item.type === 'string') {
        var type = norm(item.type);
        if (type) list.push({ type: type, url: item.url });
        continue;
      }
      if (typeof item.filter !== 'string') continue;
      var pairs = pairsOf(queryOf(item.filter));
      if (!pairs.length) continue;
      list.push({ key: stateKey(pairs), url: item.url });
    }
    return list;
  }

  /* Last match wins, like the Liquid matcher (loop without break). type is the normalized option value
     when the click would leave only that Product type option selected, otherwise null. */
  function urlFor(key, type) {
    for (var i = entries.length - 1; i >= 0; i--) {
      var entry = entries[i];
      if (entry.type ? entry.type === type : entry.key === key) return entry.url;
    }
    return null;
  }

  /* Entry URL the option should link to, or null. */
  function targetFor(control, current, currentKey) {
    var role = control.getAttribute('role');
    if (role !== 'checkbox' && role !== 'radio') return null;
    /* Checked options never become links. */
    if (control.getAttribute('aria-checked') === 'true') return null;
    if ((' ' + (control.getAttribute('class') || '') + ' ').indexOf(' checked ') !== -1) return null;
    var fvalue = control.getAttribute('data-fvalue');
    if (fvalue === null) return null;
    var block = control.closest ? control.closest('[data-filter-id]') : null;
    if (!block) return null;
    var key = prefix() + block.getAttribute('data-filter-id');
    var pair = key + '=' + fvalue;
    var result = [];
    var i;
    if (role === 'checkbox') {
      var had = false;
      for (i = 0; i < current.length; i++) {
        if (current[i] === pair) had = true;
        else result.push(current[i]);
      }
      if (!had) result.push(pair);
    } else {
      for (i = 0; i < current.length; i++) {
        if (current[i].indexOf(key + '=') !== 0) result.push(current[i]);
      }
      result.push(pair);
    }
    var resultKey = stateKey(result);
    if (resultKey === currentKey) return null;
    var type = null;
    if (result.length === 1 && result[0] === pair && TYPE_SOURCE.test(block.getAttribute('data-filter-type') || '')) {
      type = norm(fvalue);
    }
    return urlFor(resultKey, type);
  }

  /* The link leads to a filtered state of this very page (not to another collection or a type page). */
  function samePage(a) {
    var path = a.pathname;
    if (typeof path !== 'string') return false;
    return path.replace(/\/+$/, '').toLowerCase() === location.pathname.replace(/\/+$/, '').toLowerCase();
  }

  function onLinkClick(event) {
    /* Modified clicks (new tab/window) and links to another page keep the browser default (the href);
       Globo's delegated handler must not see them. */
    if (event.button || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || !samePage(this)) {
      event.stopPropagation();
      return;
    }
    /* Same page: no navigation. The click bubbles on to Globo's delegated handler (document,
       '.gf-option-box li button, .gf-option-box li a'), which reads role/data-fvalue from this <a> and filters
       via AJAX + pushState to the same URL as the href. Hands off the options until Globo re-renders. */
    event.preventDefault();
    holdUntil = new Date().getTime() + HOLD_MS;
    setTimeout(schedule, HOLD_MS + 50);
  }

  function onLinkKeydown(event) {
    var key = event.key;
    if (key === ' ' || key === 'Spacebar' || event.keyCode === 32) {
      event.preventDefault();
      event.stopPropagation();
      this.click();
    }
  }

  /* Visual parity with the replaced <button>. Globo styles "li a" and "li button" alike, except:
     - theme.css "button,.btn" (gap, centring, nowrap, radius, transition) has no <a> counterpart;
     - globo.theme.hyper.css gives "li a" color foreground !important, "li button" color subtext !important;
     - globo.theme.hyper.css swatch hover ring and box-rectangle base/hover exist only for "button".
     The #id selector outranks the !important Globo rules. Linked options are never .checked (except for the
     moment between a click handed to Globo and its re-render). */
  function injectStyle() {
    if (document.getElementById('CollectionFilterSeoLinksStyle')) return;
    var a = ' .gf-option-box li > a[' + LINK_ATTR + ']';
    var sel = '#gf-tree' + a;
    var sw = '#gf-tree .gf-option-block-swatch' + a;
    var swt = '#gf-tree .gf-option-block-swatch-text' + a;
    var box = '#gf-tree .gf-option-block-box-rectangle' + a.replace(' li ', ' li.gf-box-rectangle ');
    var style = document.createElement('style');
    style.id = 'CollectionFilterSeoLinksStyle';
    style.textContent = sel + ':not(.checked){color:rgba(var(--color-subtext),var(--color-subtext-alpha,1))!important}' +
      sel + '{justify-content:center;gap:0 var(--buttons-gap,.4rem);white-space:nowrap;text-align:center;' +
      'border-radius:var(--buttons-radius,0);transition:background .3s,color .3s;text-decoration:none}' +
      sel + ':hover{text-decoration:none}' +
      sw + ',' + swt + '{transition:box-shadow .3s ease-in-out,-webkit-box-shadow .25s ease-in-out,outline .3s ease}' +
      sw + ':hover>span,' + swt + ':hover>span:not(.gf-option-value,.gf-label)' +
      '{border:0;outline:.2rem solid rgba(var(--color-foreground),.45)}' +
      box + '{background:rgb(var(--color-background))!important;border:1px solid rgb(var(--color-foreground))!important;' +
      'border-radius:.4rem}' +
      box + ':hover{background:rgb(var(--color-foreground))!important;border:1px solid rgb(var(--color-foreground))!important}';
    (document.head || document.documentElement).appendChild(style);
  }

  function copyInto(from, to) {
    for (var i = 0; i < COPY_ATTRS.length; i++) {
      var v = from.getAttribute(COPY_ATTRS[i]);
      if (v !== null) to.setAttribute(COPY_ATTRS[i], v);
    }
    for (var n = from.firstChild; n; n = n.nextSibling) to.appendChild(n.cloneNode(true));
    return to;
  }

  function makeLink(button, url) {
    var a = copyInto(button, document.createElement('a'));
    a.setAttribute('href', url);
    a.setAttribute(LINK_ATTR, '');
    a.addEventListener('click', onLinkClick);
    a.addEventListener('keydown', onLinkKeydown);
    a._cfsButton = button;
    return a;
  }

  function apply() {
    if (entries === null) entries = loadEntries();
    var tree = document.getElementById('gf-tree');
    watch(tree);
    if (!tree || !entries.length) return;
    /* A link click was handed to Globo: leave its options alone until Globo re-renders. */
    if (new Date().getTime() < holdUntil) return;
    var current = pairsOf(location.search);
    var currentKey = stateKey(current);

    var links = tree.querySelectorAll('.gf-option-box li > a[' + LINK_ATTR + ']');
    var i;
    for (i = 0; i < links.length; i++) {
      var a = links[i];
      var original = a._cfsButton;
      var want = original ? targetFor(a, current, currentKey) : null;
      if (want && want === a.getAttribute('href')) continue;
      if (!a.parentNode) continue;
      if (!original) {
        /* Orphan clone (tree copied/replaced without our listeners): rebuild the Globo button. */
        original = copyInto(a, document.createElement('button'));
        original.setAttribute('type', 'button');
      }
      a.parentNode.replaceChild(original, a);
    }

    var buttons = tree.querySelectorAll('.gf-option-box li > button[data-fvalue]');
    for (i = 0; i < buttons.length; i++) {
      var button = buttons[i];
      var url = targetFor(button, current, currentKey);
      if (url && button.parentNode) button.parentNode.replaceChild(makeLink(button, url), button);
    }
  }

  function schedule() {
    if (timer) clearTimeout(timer);
    timer = setTimeout(function () {
      timer = null;
      apply();
    }, 80);
  }

  /* MutationObserver fallback: on document.body until #gf-tree exists, then on #gf-tree (subtree) plus
     its parent (childList only), so a silently replaced #gf-tree is re-watched and re-linked. */
  function watch(tree) {
    if (!window.MutationObserver) return;
    var target = tree || document.body;
    var parent = tree ? tree.parentNode : null;
    if (!target || (target === observed && parent === observedParent)) return;
    if (!observer) {
      observer = new MutationObserver(function () {
        var current = document.getElementById('gf-tree');
        if (observed === document.body ? current : current !== observed) apply();
        else if (observed !== document.body) schedule();
      });
    } else {
      observer.disconnect();
    }
    observed = target;
    observedParent = parent;
    observer.observe(target, { childList: true, subtree: true });
    if (parent) observer.observe(parent, { childList: true });
  }

  /* Globo dispatches its render events synchronously BEFORE history.pushState of the new state, so the
     links are computed on the next task (schedule), when location.search is already current. */
  function onRender() {
    holdUntil = 0;
    schedule();
  }

  function start() {
    entries = loadEntries();
    if (!entries.length) return;
    injectStyle();
    window.addEventListener('globoFilterTreeRenderCompleted', onRender);
    window.addEventListener('globoFilterRenderCompleted', onRender);
    window.addEventListener('popstate', schedule);
    apply();
  }

  window.CollectionFilterSeoLinks = { apply: apply };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
